import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import { publicConsultationsListingSchema } from './schema';

const PublicConsultationsListingData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;
  const schema = publicConsultationsListingSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

PublicConsultationsListingData.propTypes = {
  data: PropTypes.shape({
    itemsLimit: PropTypes.number,
    filterByOrganization: PropTypes.bool,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default PublicConsultationsListingData;
